import * as React from 'react';

import {StatusBadge} from 'shells/status-badge/status-badge';

type Props = {
    value: string | string[] | null | undefined;
    enum: any;
};

export function CellBadge(props: Props) {
    if (!props.value || !props.value.length) {
        return null;
    }

    if (Array.isArray(props.value)) {
        return props.value.map<React.ReactNode>((singleValue) => {
            return (
                <StatusBadge
                    key={singleValue}
                    size='small'
                    level={props.enum[singleValue]}
                    text={singleValue}
                />
            );
        });
    }

    return <StatusBadge size='small' level={props.enum[props.value]} text={props.value} />;
}
